import React from 'react';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Icon from 'components/DesignSystem/Icon';
import SubtitleSemiBold from 'components/Typography/SubtitleSemiBold';
import { ProductEntry } from 'helper/Home/homeProductsList';

export default function Product({ product }: { product: ProductEntry }) {
  return (
    <Col className="product-entry">
      <Link to={product.link} className="product-link">
        <Icon iconType={product.icon} />
        <SubtitleSemiBold>{product.name}</SubtitleSemiBold>
      </Link>
    </Col>
  );
}
